<template>
  <el-dialog
    :visible.sync="visibility"
    :before-close="fechar"
    width="50%"
    v-loading="loading"
    append-to-body
  >
    <div slot="title" style="font-size: 20px;">
      <i class="el-icon-refresh"></i>
      <span>Troca de Titularidade</span>
    </div>

    <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">    
      <el-steps :active="estagioAtual" style="width: 70%;" finish-status="success" process-status="finish" align-center>
        <el-step title ="Efetuar troca"/>
        <el-step title ="Upload Aditivo"/>
      </el-steps>
    </div>
    
    <el-form :model="form" size="small" label-position="top" hide-required-asterisk v-if="estagioAtual === 0">

      <el-form-item label="Tipo entidade">
        <el-select @change="limparChangeEntidade" v-model="form.tipoEntidade" style="width: 100%;">
          <el-option
            v-for="tipo in tiposEntidade" :key="tipo.id"
            :label="tipo.label"
            :value="tipo.data"
          />
        </el-select>
      </el-form-item>
      
      <div style="margin-top: 30px;" v-if="form.tipoEntidade === 'PROPRIETARIO'">
        <table class="tabela-detalhes-clientes">
          <thead>
            <th scope="col">Nome</th>
            <th scope="col">Perfil</th>
            <th></th>
          </thead>

          <tbody>
            <tr v-for="(proprietario, index) in listaProprietarios" :key="index">
              <td>{{ proprietario.nome }}</td>
              <td>
               {{ proprietario.perfil }}
              </td>
              <td>
                <el-tooltip :content="verificarProprietarioComTrocaAtiva(proprietario) ? 'Cancelar Troca' : 'Trocar Proprietário'">
                  <el-button @click="selecionarProprietarioParaTroca(index)" :disabled="proprietarioSelecionadoParaTroca !== undefined" v-if="!verificarProprietarioComTrocaAtiva(proprietario)" circle icon="el-icon-refresh" type="warning" size="small"/>
                  <el-button @click="desselecionarProprietarioParaTroca(index)" v-else circle icon="el-icon-close" type="danger" size="small"/>
                </el-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style="margin-top: 30px;" v-if="form.tipoEntidade === 'LOCATARIO'">
        <table class="tabela-detalhes-clientes">
          <thead>
            <th scope="col">Nome</th>
            <th scope="col">Perfil</th>
            <th></th>
          </thead>

          <tbody>
            <tr>
              <td>{{ locatario.nome }}</td>
              <td>
               {{ 'Locatário' }}
              </td>
              <td>
                <el-tooltip :content="isSelecionarNovoLocatario ? 'Cancelar Troca' : 'Trocar Locatário'">
                  <el-button @click="trocarLocatario" v-if="!isSelecionarNovoLocatario" circle icon="el-icon-refresh" type="warning" size="small"/>
                  <el-button @click="isSelecionarNovoLocatario = false" v-else circle icon="el-icon-close" type="danger" size="small"/>
                </el-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-form-item :label="isEntidadeProprietario ? 'Novo Proprietário' : 'Novo Locatário'" v-if="isExibirNovoCliente">
        <div style="display: flex; flex-direction: row; gap: 8px;">
          <el-select
            v-model="clientePesquisado"
            :remote-method="filtrarClientesSelect"
            :loading="loadingCliente"
            value-key="id"
            placeholder="Digite o Nome ou Id do Cliente"
            loading-text="Carregando Clientes"
            no-data-text=""
            filterable
            clearable
            @clear="clientePesquisado = undefined"
            remote
            reserve-keyword
            style="width: 100%"
          >
            <el-option
              v-for="item in clientesDisponiveisFiltrado"
              :key="item.id"
              :label="`(${item.idNaImobiliaria})${item.nome}`"
              :value="item"
            />
          </el-select>
          <el-button v-if="clientePesquisado" icon="el-icon-refresh" round class="btn-box-shadow" type="success" @click="alterarProprietarioLocatarioHandler()">Confirmar</el-button>
        </div>
      </el-form-item>
    </el-form>

    <el-form :model="form" size="small" label-position="top" hide-required-asterisk v-if="estagioAtual === 1">
      <el-form-item label="Upload Arquivo Aditivo:">
        <el-upload :file-list="listFiles" :on-change="handleChangeUpload" :on-remove="limparListaArquivos" name="arquivo" :action="''" :multiple="false" :limit="1" :auto-upload="false" class="file-upload-box">
          <el-button type="primary" slot="trigger" style="width: 100%" icon="el-icon-search" round class="btn-box-shadow">Selecionar Arquivo</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item label=" " v-if="hasFileSelected">
        <el-button @click="uploadArquivo" round class="btn-box-shadow" type="success" style="width: 100%;" icon="el-icon-upload">Confirmar Upload</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    visibility: Boolean,
    proprietarios: Array,
    locatario: Object,
    aluguel: Object,
    imovel: Object
  },

  data() {
    return {
      form: {
        tipoEntidade: 'PROPRIETARIO'
      },

      listFiles: [],

      clientePesquisado: undefined,

      tiposEntidade: [
        { label: 'Proprietário', data: 'PROPRIETARIO' },
        { label: 'Locatário', data: 'LOCATARIO' }
      ],

      loadingCliente: false,

      isSelecionarNovoLocatario: false,

      listaProprietarios: JSON.parse(JSON.stringify(this.proprietarios)),

      estagioAtual: 0
    }
  },

  watch: {
    proprietarios: {
      handler(novo) {
        if(!novo || !novo.length) return

        this.listaProprietarios = JSON.parse(JSON.stringify(novo))
      }
    }
  },

  computed: {
    ...mapState('alugueisRelatoriosStore', {
      clientesDisponiveis(state) { return state.clientesDisponiveis },
    }),

    clientesDisponiveisFiltrado() {
      return this.clientesDisponiveis.filter((cliente) => {
        if(this.proprietarioSelecionadoParaTroca) {
          return cliente.id !== this.proprietarioSelecionadoParaTroca.id
        } else {
          return cliente.id
        }
      })
      .filter((cliente) => {
        return cliente.id !== this.locatario.id
      })
    },

    proprietarioSelecionadoParaTroca() {
      return this.listaProprietarios.filter((proprietario) => proprietario.isSelecionadoParaTroca)[0];
    },

    isEntidadeProprietario() {
      return this.form.tipoEntidade === 'PROPRIETARIO'
    },

    isEntidadeLocatario() {
      return this.form.tipoEntidade === 'LOCATARIO'
    },

    isExibirNovoCliente() {
      return this.proprietarioSelecionadoParaTroca || this.isSelecionarNovoLocatario
    },

    loading() {
      return this.$store.state.loading;
    },

    hasFileSelected() {
      return this.listFiles.length > 0
    }
  },

  methods: {
    ...mapActions(['showLoading', 'hideLoading']),
    ...mapActions("alugueisRelatoriosStore", ["listarClientes"]),
    ...mapActions("alugueisContratosStore", ["trocarTitularidadeProprietario", "uploadArquivoAluguel", "trocarTitularidadeLocatario"]),

    trocarProprietario() {
      
    },

    trocarLocatario() {
      this.isSelecionarNovoLocatario = true;
    },

    verificarProprietarioComTrocaAtiva(proprietarioLista) {
      return this.proprietarioSelecionadoParaTroca && (proprietarioLista.id == this.proprietarioSelecionadoParaTroca.id);
    },

    selecionarProprietarioParaTroca(index) {
      let proprietarioSelecionado = this.listaProprietarios[index];
      proprietarioSelecionado.isSelecionadoParaTroca = true;

      this.listaProprietarios[index] = proprietarioSelecionado;
    },

    desselecionarProprietarioParaTroca(index) {
      let proprietarioSelecionado = this.listaProprietarios[index]
      proprietarioSelecionado.isSelecionadoParaTroca = false;

      this.listaProprietarios[index] = proprietarioSelecionado;
    },

    alterarProprietarioLocatarioHandler() {
      switch (this.form.tipoEntidade) {
        case 'PROPRIETARIO':
          this.alterarProprietarioHandler();
          break;
        case 'LOCATARIO':
          this.alterarLocatarioHandler();
          break;
      }
    },

    alterarProprietarioHandler() {
      if(!this.clientePesquisado) {
        return
      }

      this.$confirm("Ao alterar a titularidade, todos os repasses em aberto serão transferidos ao novo proprietário. Deseja realmente continuar?", {
        confirmButton: 'Confirmar',
        cancelButton: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.alterarProprietario();
      })
    },

    alterarLocatarioHandler() {
      if(!this.clientePesquisado) {
        return;
      }

      this.$confirm("Ao alterar a titularidade, todos os recibos em aberto e não registrados serão transferidos ao novo proprietário. Deseja realmente continuar?", {
        confirmButton: 'Confirmar',
        cancelButton: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.alterarLocatario();
      })
    },

    alterarProprietario() {
      const payload = this.montarPayloadProprietario();

      this.showLoading();

      this.trocarTitularidadeProprietario(payload)
      .then(resposta => {
        switch (resposta.status) {
          case 'SUCESSO':
            this.$message.success(resposta.mensagem);

            this.estagioAtual = 1;
            break;
          case 'FALHA':
            this.$message.warning(resposta.mensagem);
            break;
          default: 
            this.$message.error(resposta.mensagem);
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
      }) .finally(() => {
        this.hideLoading();
      })
    },

    alterarLocatario() {
      const payload = this.montarPayloadLocatario();

      this.showLoading();

      this.trocarTitularidadeLocatario(payload)
      .then(resposta => {
        switch (resposta.status) {
          case 'SUCESSO':
            this.$message.success(resposta.mensagem);

            this.estagioAtual = 1;

            break;
          case 'FALHA':
            this.$message.warning(resposta.mensagem);
            break;
          default:
            this.$message.error(resposta.mensagem);
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor.');
      }).finally(() => {
        this.hideLoading();
      })
    },

    montarPayloadProprietario() {
      return {
        tipoEntidade: 'PROPRIETARIO',
        aluguel: this.aluguel,
        imovel: this.imovel,
        clienteAnterior: {...this.proprietarioSelecionadoParaTroca, isSelecionadoParaTroca: undefined},
        clienteNovo: this.clientePesquisado
      }
    },

    montarPayloadLocatario() {
      return {
        tipoEntidade: 'LOCATARIO',
        aluguel: this.aluguel,
        imovel: this.imovel,
        clienteAnterior: this.locatario,
        clienteNovo: this.clientePesquisado
      }
    },

    uploadArquivo() {
      let payload = new FormData();

      payload.append("arquivo", this.listFiles[0].raw);
      payload.append("descricao", "Aditivo troca de Titularidade.");
      payload.append("localizacaoFisica", this.arquivo.localizacaoFisica);
      payload.append("path", this.listFiles[0].name);

      payload.append("idAluguel", this.aluguel.id); 

      this.showLoading()
      this.uploadArquivoAluguel(payload)
      .then(resultado => {
        this.hideLoading();

        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      }).finally(() => {
        this.fechar();
      });
    },

    handleChangeUpload(file, fileList) {
      this.listFiles = fileList;
    },

    limparListaArquivos() {
      this.listFiles = []
    },

    filtrarClientesSelect(queryString) {
      let payload = { };

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingCliente = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingCliente = false;
        })
        .catch(() => {
          this.loadingCliente = false;
        });
    },
    
    fechar() {
      this.$emit('close');
      this.limparForm();
    },

    limparForm() {
      this.form = {
        tipoEntidade: 'PROPRIETARIO',
      }

      this.listFiles = []

      this.estagioAtual = 0;

      this.limparChangeEntidade();
    },

    limparChangeEntidade() {
      this.isSelecionarNovoLocatario = false;

      this.listaProprietarios = JSON.parse(JSON.stringify(this.proprietarios));
    }
  }
}
</script>

<style>
.tabela-detalhes-clientes {
  border-collapse: separate ;
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 25px;
  box-shadow: 
    inset 0 1px 0 #ffffff,
    0 0 8px rgba(0, 0, 0, 0.1);
}

.tabela-detalhes-clientes td {
  border: none;
  border-bottom: 1px solid #b8b3b3;
  padding: 8px 10px;
}

.tabela-detalhes-clientes th {
  border: none;
  border-bottom: 1px solid #b8b3b3;
  padding: 8px 10px;
}

.tabela-detalhes-clientes tr:last-child td{
  border-bottom: none;
}

.no-increase .el-input-number__increase {
  pointer-events: none;
  opacity: 0.4;
}
</style>